import React, { useMemo } from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { buildWhatsappInteractivePresentation, isTechnicalWhatsappChoiceId } from "../../utils/whatsappInteractiveDisplay";

function isWhatsappContext(message, defaultChannel) {
  const blob = `${message?.channel || ""} ${defaultChannel || ""}`.toLowerCase();
  return /\bwhatsapp\b/.test(blob);
}

/**
 * Opções de botão/lista enviadas (quando o JSON da mensagem contém o payload).
 */
export default function WhatsappInteractiveBlocks({ message, defaultChannel, isClient }) {
  const pres = useMemo(
    () => buildWhatsappInteractivePresentation(message, null, null),
    [message?.id, message?.json_whatsapp]
  );

  const isWa = isWhatsappContext(message, defaultChannel);
  if (!isWa || !pres.outboundOptions.length || isClient) return null;

  return (
    <Box sx={{ mt: 1, pt: 1, borderTop: "1px dashed", borderColor: "divider" }}>
      <Typography variant="caption" sx={{ display: "block", mb: 0.5, opacity: 0.88 }}>
        Botões / lista enviados
      </Typography>
      <Stack direction="row" flexWrap="wrap" gap={0.5}>
        {pres.outboundOptions.map((o, i) => (
          <Chip
            key={`${o.id}-${i}`}
            size="small"
            label={o.section ? `${o.section}: ${o.title || o.id}` : o.title || o.id}
            variant="outlined"
            sx={{ borderStyle: "dashed", maxWidth: "100%", "& .MuiChip-label": { whiteSpace: "normal", textAlign: "left" } }}
          />
        ))}
      </Stack>
    </Box>
  );
}

/**
 * Rodapé para respostas do cliente: referência técnica quando o texto foi traduzido para rótulo legível.
 */
export function WhatsappInboundChoiceFooter({ message, textOverride, defaultChannel }) {
  const isWa = isWhatsappContext(message, defaultChannel);
  const raw = message?.text != null ? String(message.text).trim() : "";
  if (!isWa || !textOverride || !raw || textOverride === raw) return null;
  if (!isTechnicalWhatsappChoiceId(raw)) return null;

  return (
    <Typography variant="caption" sx={{ display: "block", mt: 0.5, opacity: 0.78 }}>
      ID no WhatsApp: <Box component="code" sx={{ fontSize: "0.8em" }}>{raw}</Box>
    </Typography>
  );
}
